var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9FB36D1-E5AC-4694-943E-B915E62C7123") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-My-profile_D&H-Copy_dropdown",
    transform: "translate(-315.000000, -839.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(0.000000, 823.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(333.000000, 34.000000) rotate(180.000000) translate(-333.000000, -34.000000) translate(315.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8EDAEA",
    cx: 18,
    cy: 18,
    r: 17.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8EDAEA",
    fillRule: "nonzero",
    points: "25 15.3412604 23.59 14 18 19.3174792 12.41 14 11 15.3412604 16.59 20.6587396 18 22 19.41 20.6587396"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedChevronUp);
export default __webpack_public_path__ + "static/media/rounded-chevron-up.cc775b2cf7eb846c098bf0d70fa049af.svg";
export { ForwardRef as ReactComponent };